export default "__VITE_ASSET__D2Rew4pb__"